module.exports = __webpack_public_path__ + "img/26.6f55fe48.jpg";